import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/Button/Button'

import { type DocumentRecord } from '../../../models/Document'

import { selectDocumentBatchDocuments } from '../../../store/processDocument/documentBatch'
import { selectDocumentBatchNavigationDisabled } from '../../../store/processDocument/processDocument'
import { useAppSelector } from '../../../store/hooks'

interface DocumentBatchNavigationProps {
  documentId: string
}

export const DocumentBatchNavigation: React.FC<DocumentBatchNavigationProps> = ({ documentId }) => {
  const navigate = useNavigate()

  const batchDocuments = useAppSelector(selectDocumentBatchDocuments)
  const navigationDisabled = useAppSelector(selectDocumentBatchNavigationDisabled)

  const currentIndex = batchDocuments.findIndex((document) => document.id === documentId)

  const normalizedIndex = currentIndex > -1 ? currentIndex + 1 : currentIndex

  const navigateToNextDocument = (nextDocument: DocumentRecord) => {
    navigate(`/document-batches/${nextDocument.documentBatchId}/documents/${nextDocument.id}`)
  }

  return (
    <div className='d-flex align-items-center gap-3'>
      <span className='paragraph-medium flex-shrink-0'>
        {normalizedIndex} of {batchDocuments.length} documents
      </span>
      <div className='d-flex align-items-center'>
        <Button
          variant='borderless'
          className='p-1'
          disabled={navigationDisabled || !batchDocuments[currentIndex - 1]}
          onClick={() => navigateToNextDocument(batchDocuments[currentIndex - 1])}
        >
          <span className='document-batch-navigation-icon d-flex align-items-center justify-content-center'>
            <i className='bi bi-chevron-left fs-6' />
          </span>
        </Button>
        <Button
          variant='borderless'
          className='p-1'
          disabled={navigationDisabled || !batchDocuments[currentIndex + 1]}
          onClick={() => navigateToNextDocument(batchDocuments[currentIndex + 1])}
        >
          <span className='document-batch-navigation-icon d-flex align-items-center justify-content-center'>
            <i className='bi bi-chevron-right fs-6' />
          </span>
        </Button>
      </div>
    </div>
  )
}
